import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid , Header , Image , Button } from 'semantic-ui-react';
import { Link } from "react-router";
import ThemeColorSetting from '../../constants/themeColor';
import pitch2Banner from '../../assets/home/pitch2Banner.png';
import squareGrpah from '../../assets/pattern/squares.svg';

const styles = {
  coverContainer : {
    backgroundColor : ThemeColorSetting.grey,
    backgroundImage: 'url(' +squareGrpah+ ')',
		backgroundSize : '25px 25px',
		backgroundRepeat : 'repeat',
    padding : '80px 0px'
  },
  descriptionWrapper : {
    display : 'flex' ,
    flexDirection : 'column',
    justifyContent : 'center',
    padding : '5vh'
  },
  description : {
    fontSize : '20px',
    color : ThemeColorSetting.black,
    lineHeight: '200%'
  },
  imageWrapper : {
    display : 'flex' ,
    alignItems : 'center' ,
    justifyContent : 'center'
  },
  header : {
    color : ThemeColorSetting.black,
    fontSize : '50px'
  },
  moreFeatureButton : {
    backgroundColor : ThemeColorSetting.red,
    color : 'white' ,
    width : '20vh'
  }
}

class uiPitch extends Component {
  render() {
    const { string , mixpanel } = this.props;
    return(
      <Grid.Row columns='2' style={styles.coverContainer}>
        <Grid.Column style={styles.descriptionWrapper}>
          <Header as='h1' style={styles.header}>{string['pich2Header']}</Header>
          <p style={styles.description}>{string['pitch2Content']}</p>
          <Link to={{ pathname : '/features' , query : { device : 'mobileDevices' , feature : 'addInvoice' } }}><Button onClick={()=>mixpanel.track("Pitch Page", { action : 'link to', url : "Feature Page" })} style={styles.moreFeatureButton} size={'medium'}>{string['linkToFeatures']}</Button></Link>
        </Grid.Column>
        <Grid.Column style={styles.imageWrapper}>
          <Image src={pitch2Banner} size={'huge'}/>
        </Grid.Column>
      </Grid.Row>
    )
  }
}

function mapStateToProps(state) {
  return {
    string : state.preference.string,
    mixpanel : state.ui.tempData.mixpanel
  }
}

export default connect(mapStateToProps,null)(uiPitch)



/** WEBPACK FOOTER **
 ** ./src/containers/pitch/uiPitch.js
 **/